import { type FC } from 'react';
import { ReactComponent as MinusIcon } from 'assets/icons/button-icons/minus-bold.svg';
import { ReactComponent as PlusIcon } from 'assets/icons/button-icons/plus-bold.svg';

import * as S from './ButtonsContainer.styled';

interface IButtonsContainerProps {
  id: number;
  inputValue: number;
  isIncrementDisabled: boolean;
  isInputFocused: boolean;
  handleIncrement: (id: number) => void;
  handleDecrement: (id: number) => void;
  handleInputChange: (e: React.ChangeEvent<HTMLInputElement>, id: number) => void;
  handleMouseLeave: (e: React.MouseEvent<HTMLDivElement>) => void;
  handleMouseEnter: (e: React.MouseEvent<HTMLDivElement>) => void;
  handleInputFocused: (value: boolean) => void;
  handleBlur: (id: number) => void;
  handleKeyDown: (e: React.KeyboardEvent<HTMLInputElement>, id: number) => void;
}

export const ButtonsContainer: FC<IButtonsContainerProps> = ({
  id,
  inputValue,
  isIncrementDisabled,
  isInputFocused,
  handleIncrement,
  handleDecrement,
  handleInputChange,
  handleMouseLeave,
  handleMouseEnter,
  handleInputFocused,
  handleBlur,
  handleKeyDown,
}) => {
  return (
    <S.ButtonsWrapper
      onMouseLeave={handleMouseLeave}
      onMouseEnter={handleMouseEnter}
      onBlur={() => {
        handleInputFocused(false);
        handleBlur(id);
      }}
    >
      <S.CounterButton
        type="button"
        icon={<MinusIcon />}
        onClick={() => handleDecrement(id)}
        disabled={inputValue === 0}
        data-testid={'minusButton'}
      />
      <S.CounterInput
        type="text"
        value={inputValue}
        $isInputFocused={isInputFocused}
        onChange={(e) => handleInputChange(e, id)}
        onFocus={() => handleInputFocused(true)}
        onKeyDown={(e) => {
          if (e.key === 'Enter') {
            handleInputFocused(false);
          }

          handleKeyDown(e, id);
        }}
      />
      <S.CounterButton
        type="button"
        icon={<PlusIcon />}
        disabled={isIncrementDisabled}
        onClick={() => handleIncrement(id)}
        data-testid={'plusButton'}
      />
    </S.ButtonsWrapper>
  );
};
